import { generateId } from "../functions/generate-firestore-id.function";
import { Channel, ChannelOverride, FerryRotoMachine } from "./factory-node-hardware.config";

export type FerryRotoMachineChannels = {
    oven_entry_door_open_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Open Switch",
        machineName: "oven_entry_door_open_switch",
        description: "Switch that indicates the oven entry door is open.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_door_closed_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Closed Switch",
        machineName: "oven_entry_door_closed_switch",
        description: "Switch that indicates the oven entry door is closed.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_open_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Open Switch",
        machineName: "oven_exit_door_open_switch",
        description: "Switch that indicates the oven exit door is open.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_closed_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Closed Switch",
        machineName: "oven_exit_door_closed_switch",
        description: "Switch that indicates the oven exit door is closed.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    alarm_silence_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Alarm Silence Pushbutton",
        machineName: "alarm_silence_pushbutton",
        description: "Indicates that the alarm silence pushbutton is pressed.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_index_auto_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm Index Auto Selector Switch",
        machineName: "arm_index_auto_selector_switch",
        description: "Indicates that the arm index selector switch is set to auto.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_index_manual_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm Index Manual Selector Switch",
        machineName: "arm_index_manual_selector_switch",
        description: "Indicates that the arm index selector switch is set to manual.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_index_reverse_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm Index Reverse Selector Switch",
        machineName: "arm_index_reverse_selector_switch",
        description: "Indicates that the arm index selector switch is set to reverse.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    drives_start_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Drives Start Pushbutton",
        machineName: "drives_start_pushbutton",
        description: "Indicates that the drives start pushbutton is pressed.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    drives_stop_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Drives Stop Pushbutton",
        machineName: "drives_stop_pushbutton",
        description: "Indicates that the drives stop pushbutton is pressed.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    unload_pedestal_arm_jog_fwd_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Unload Pedestal Arm Jog Fwd Selector Switch",
        machineName: "unload_pedestal_arm_jog_fwd_selector_switch",
        description: "Indicates that the unload pedestal arm jog selector switch is set to forward.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    unload_pedestal_arm_jog_rev_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Unload Pedestal Arm Jog Rev Selector Switch",
        machineName: "unload_pedestal_arm_jog_rev_selector_switch",
        description: "Indicates that the unload pedestal arm jog selector switch is set to reverse.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    unload_pedestal_plate_jog_fwd_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Unload Pedestal Plate Jog Fwd Selector Switch",
        machineName: "unload_pedestal_plate_jog_fwd_selector_switch",
        description: "Indicates that the unload pedestal plate jog selector switch is set to forward.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    unload_pedestal_plate_jog_rev_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Unload Pedestal Plate Jog Rev Selector Switch",
        machineName: "unload_pedestal_plate_jog_rev_selector_switch",
        description: "Indicates that the unload pedestal plate jog selector switch is set to reverse.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    load_pedestal_arm_jog_fwd_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Load Pedestal Arm Jog Fwd Selector Switch",
        machineName: "load_pedestal_arm_jog_fwd_selector_switch",
        description: "Indicates that the load pedestal arm jog selector switch is set to forward.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    load_pedestal_arm_jog_rev_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Load Pedestal Arm Jog Rev Selector Switch",
        machineName: "load_pedestal_arm_jog_rev_selector_switch",
        description: "Indicates that the load pedestal arm jog selector switch is set to reverse.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    load_pedestal_plate_jog_fwd_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Load Pedestal Plate Jog Fwd Selector Switch",
        machineName: "load_pedestal_plate_jog_fwd_selector_switch",
        description: "Indicates that the load pedestal plate jog selector switch is set to forward.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    load_pedestal_plate_jog_rev_selector_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Load Pedestal Plate Jog Rev Selector Switch",
        machineName: "load_pedestal_plate_jog_rev_selector_switch",
        description: "Indicates that the load pedestal plate jog selector switch is set to reverse.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    load_arm_ready_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Load Arm Ready Pushbutton",
        machineName: "load_arm_ready_pushbutton",
        description: "Indicates that the arm ready pushbutton is pressed on the load station pedestal.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    load_cycle_reset_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Load Cycle Reset Pushbutton",
        machineName: "load_cycle_reset_pushbutton",
        description: "Indicates that the cycle reset pushbutton is pressed on the load station pedestal.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    unload_arm_ready_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Unload Arm Ready Pushbutton",
        machineName: "unload_arm_ready_pushbutton",
        description: "Indicates that the arm ready pushbutton is pressed on the unload station pedestal.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    unload_cycle_reset_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Unload Cycle Reset Pushbutton",
        machineName: "unload_cycle_reset_pushbutton",
        description: "Indicates that the cycle reset pushbutton is pressed on the unload station pedestal.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    cart_1_at_load_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 at Load Station Prox Switch",
        machineName: "cart_1_at_load_station_prox_switch",
        description: "Indicates that cart 1 is at the load station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_at_oven_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 at Oven Prox Switch",
        machineName: "cart_1_at_oven_prox_switch",
        description: "Indicates that cart 1 is at the oven.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_at_wait_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 at Wait Station Prox Switch",
        machineName: "cart_1_at_wait_station_prox_switch",
        description: "Indicates that cart 1 is at the wait station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_at_cooling_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 at Cooling Station Prox Switch",
        machineName: "cart_1_at_cooling_station_prox_switch",
        description: "Indicates that cart 1 is at the cooling station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_at_unload_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 at Unload Station Prox Switch",
        machineName: "cart_1_at_unload_station_prox_switch",
        description: "Indicates that cart 1 is at the unload station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_index_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 Index Pushbutton",
        machineName: "cart_1_index_pushbutton",
        description: "Indicates that the index pushbutton is pressed for cart 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    cart_2_at_load_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 at Load Station Prox Switch",
        machineName: "cart_2_at_load_station_prox_switch",
        description: "Indicates that cart 2 is at the load station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_at_oven_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 at Oven Prox Switch",
        machineName: "cart_2_at_oven_prox_switch",
        description: "Indicates that cart 2 is at the oven.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_at_wait_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 at Wait Station Prox Switch",
        machineName: "cart_2_at_wait_station_prox_switch",
        description: "Indicates that cart 2 is at the wait station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_at_cooling_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 at Cooling Station Prox Switch",
        machineName: "cart_2_at_cooling_station_prox_switch",
        description: "Indicates that cart 2 is at the cooling station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_at_unload_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 at Unload Station Prox Switch",
        machineName: "cart_2_at_unload_station_prox_switch",
        description: "Indicates that cart 2 is at the unload station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_index_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 Index Pushbutton",
        machineName: "cart_2_index_pushbutton",
        description: "Indicates that the index pushbutton is pressed for cart 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    cart_3_at_load_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 at Load Station Prox Switch",
        machineName: "cart_3_at_load_station_prox_switch",
        description: "Indicates that cart 3 is at the load station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_at_oven_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 at Oven Prox Switch",
        machineName: "cart_3_at_oven_prox_switch",
        description: "Indicates that cart 3 is at the oven.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_at_wait_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 at Wait Station Prox Switch",
        machineName: "cart_3_at_wait_station_prox_switch",
        description: "Indicates that cart 3 is at the wait station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_at_cooling_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 at Cooling Station Prox Switch",
        machineName: "cart_3_at_cooling_station_prox_switch",
        description: "Indicates that cart 3 is at the cooling station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_at_unload_station_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 at Unload Station Prox Switch",
        machineName: "cart_3_at_unload_station_prox_switch",
        description: "Indicates that cart 3 is at the unload station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_index_pushbutton: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 Index Pushbutton",
        machineName: "cart_3_index_pushbutton",
        description: "Indicates that the index pushbutton is pressed for cart 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    plate_1_cam_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Cam Prox Switch",
        machineName: "plate_1_cam_prox_switch",
        description: "Indicates that plate 1 proximity switch is triggered.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_cam_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Cam Prox Switch",
        machineName: "arm_1_cam_prox_switch",
        description: "Indicates that arm 1 proximity switch is triggered.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_brake_relay: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Brake Relay",
        machineName: "arm_1_brake_relay",
        description: "Indicates that arm 1 brake relay is active.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_brake_relay: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Brake Relay",
        machineName: "plate_1_brake_relay",
        description: "Indicates that plate 1 brake relay is active.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    plate_2_cam_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Cam Prox Switch",
        machineName: "plate_2_cam_prox_switch",
        description: "Indicates that plate 2 proximity switch is triggered.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_cam_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Cam Prox Switch",
        machineName: "arm_2_cam_prox_switch",
        description: "Indicates that arm 2 proximity switch is triggered.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_brake_relay: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Brake Relay",
        machineName: "arm_2_brake_relay",
        description: "Indicates that arm 2 brake relay is active.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_brake_relay: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Brake Relay",
        machineName: "plate_2_brake_relay",
        description: "Indicates that plate 2 brake relay is active.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    plate_3_cam_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Cam Prox Switch",
        machineName: "plate_3_cam_prox_switch",
        description: "Indicates that plate 3 proximity switch is triggered.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_cam_prox_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Cam Prox Switch",
        machineName: "arm_3_cam_prox_switch",
        description: "Indicates that arm 3 proximity switch is triggered.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_brake_relay: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Brake Relay",
        machineName: "arm_3_brake_relay",
        description: "Indicates that arm 3 brake relay is active.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_brake_relay: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Brake Relay",
        machineName: "plate_3_brake_relay",
        description: "Indicates that plate 3 brake relay is active.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    flame_fail: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Flame Fail",
        machineName: "flame_fail",
        description: "Indicates that the flame has failed.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    recirculation_pressure_ok_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Recirculation Pressure OK Switch",
        machineName: "recirculation_pressure_ok_switch",
        description: "Indicates that the recirculation pressure is OK.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    exhaust_pressure_ok_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Exhaust Pressure OK Switch",
        machineName: "exhaust_pressure_ok_switch",
        description: "Indicates that the exhaust pressure is OK.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    burner_pressure_ok_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Burner Pressure OK Switch",
        machineName: "burner_pressure_ok_switch",
        description: "Indicates that the burner pressure is OK.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    high_gas_pressure_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "High Gas Pressure Switch",
        machineName: "high_gas_pressure_switch",
        description: "Indicates that the high limit gas pressure switch is tripped.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    low_gas_pressure_switch: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Low Gas Pressure Switch",
        machineName: "low_gas_pressure_switch",
        description: "Indicates that the low limit gas pressure switch is tripped.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    cart_1_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 Drive Fault",
        machineName: "cart_1_drive_fault",
        description: "Indicates that there is a fault with cart 1 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 Drive Fault",
        machineName: "cart_2_drive_fault",
        description: "Indicates that there is a fault with cart 2 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 Drive Fault",
        machineName: "cart_3_drive_fault",
        description: "Indicates that there is a fault with cart 3 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Drive Fault",
        machineName: "arm_1_drive_fault",
        description: "Indicates that there is a fault with arm 1 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Drive Fault",
        machineName: "arm_2_drive_fault",
        description: "Indicates that there is a fault with arm 2 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Drive Fault",
        machineName: "arm_3_drive_fault",
        description: "Indicates that there is a fault with arm 3 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Drive Fault",
        machineName: "plate_1_drive_fault",
        description: "Indicates that there is a fault with plate 1 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Drive Fault",
        machineName: "plate_2_drive_fault",
        description: "Indicates that there is a fault with plate 2 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Drive Fault",
        machineName: "plate_3_drive_fault",
        description: "Indicates that there is a fault with plate 3 drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Drive Fault",
        machineName: "oven_entry_drive_fault",
        description: "Indicates that there is a fault with oven entry drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Drive Fault",
        machineName: "oven_exit_drive_fault",
        description: "Indicates that there is a fault with oven exit drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    cart_1_is_not_on_station_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 is Not on Station Fault",
        machineName: "cart_1_is_not_on_station_fault",
        description: "Indicates that cart 1 is not on any station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_is_not_indexing_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 is Not Indexing Fault",
        machineName: "cart_1_is_not_indexing_fault",
        description: "Indicates that cart 1 is not indexing.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 Prox Switch Fault",
        machineName: "cart_1_prox_switch_fault",
        description: "Indicates that there is a fault with cart 1 proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_brake_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Brake Fault",
        machineName: "arm_1_brake_fault",
        description: "Indicates that there is a fault with arm 1 brake.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    arm_1_not_rotating_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Not Rotating Fault",
        machineName: "arm_1_not_rotating_fault",
        description: "Indicates that arm 1 is not rotating.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_speed_out_of_tolerance_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Speed Out of Tolerance Fault",
        machineName: "arm_1_speed_out_of_tolerance_fault",
        description: "Indicates that arm 1 speed is out of tolerance.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_switched_off_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Switched Off Fault",
        machineName: "arm_1_switched_off_fault",
        description: "Indicates that arm 1 is switched off.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_brake_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Brake Fault",
        machineName: "plate_1_brake_fault",
        description: "Indicates that there is a fault with plate 1 brake.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_not_rotating_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Not Rotating Fault",
        machineName: "plate_1_not_rotating_fault",
        description: "Indicates that plate 1 is not rotating.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_speed_out_of_tolerance_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Speed Out of Tolerance Fault",
        machineName: "plate_1_speed_out_of_tolerance_fault",
        description: "Indicates that plate 1 speed is out of tolerance.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_switched_off_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Switched Off Fault",
        machineName: "plate_1_switched_off_fault",
        description: "Indicates that plate 1 is switched off.",
        channelType: FerryMachineChannelType.DigitalInput
    }>,


    cart_2_is_not_on_station_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 is Not on Station Fault",
        machineName: "cart_2_is_not_on_station_fault",
        description: "Indicates that cart 2 is not on any station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_is_not_indexing_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 is Not Indexing Fault",
        machineName: "cart_2_is_not_indexing_fault",
        description: "Indicates that cart 2 is not indexing.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 Prox Switch Fault",
        machineName: "cart_2_prox_switch_fault",
        description: "Indicates that there is a fault with cart 2 proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_brake_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Brake Fault",
        machineName: "arm_2_brake_fault",
        description: "Indicates that there is a fault with arm 2 brake.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_not_rotating_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Not Rotating Fault",
        machineName: "arm_2_not_rotating_fault",
        description: "Indicates that arm 2 is not rotating.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_speed_out_of_tolerance_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Speed Out of Tolerance Fault",
        machineName: "arm_2_speed_out_of_tolerance_fault",
        description: "Indicates that arm 2 speed is out of tolerance.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_switched_off_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Switched Off Fault",
        machineName: "arm_2_switched_off_fault",
        description: "Indicates that arm 2 is switched off.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_brake_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Brake Fault",
        machineName: "plate_2_brake_fault",
        description: "Indicates that there is a fault with plate 2 brake.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_not_rotating_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Not Rotating Fault",
        machineName: "plate_2_not_rotating_fault",
        description: "Indicates that plate 2 is not rotating.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_speed_out_of_tolerance_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Speed Out of Tolerance Fault",
        machineName: "plate_2_speed_out_of_tolerance_fault",
        description: "Indicates that plate 2 speed is out of tolerance.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_switched_off_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Switched Off Fault",
        machineName: "plate_2_switched_off_fault",
        description: "Indicates that plate 2 is switched off.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    cart_3_is_not_on_station_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 is Not on Station Fault",
        machineName: "cart_3_is_not_on_station_fault",
        description: "Indicates that cart 3 is not on any station.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_is_not_indexing_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 is Not Indexing Fault",
        machineName: "cart_3_is_not_indexing_fault",
        description: "Indicates that cart 3 is not indexing.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 Prox Switch Fault",
        machineName: "cart_3_prox_switch_fault",
        description: "Indicates that there is a fault with cart 3 proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_brake_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Brake Fault",
        machineName: "arm_3_brake_fault",
        description: "Indicates that there is a fault with arm 3 brake.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_not_rotating_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Not Rotating Fault",
        machineName: "arm_3_not_rotating_fault",
        description: "Indicates that arm 3 is not rotating.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_speed_out_of_tolerance_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Speed Out of Tolerance Fault",
        machineName: "arm_3_speed_out_of_tolerance_fault",
        description: "Indicates that arm 3 speed is out of tolerance.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_switched_off_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Switched Off Fault",
        machineName: "arm_3_switched_off_fault",
        description: "Indicates that arm 3 is switched off.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_brake_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Brake Fault",
        machineName: "plate_3_brake_fault",
        description: "Indicates that there is a fault with plate 3 brake.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_not_rotating_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Not Rotating Fault",
        machineName: "plate_3_not_rotating_fault",
        description: "Indicates that plate 3 is not rotating.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_speed_out_of_tolerance_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Speed Out of Tolerance Fault",
        machineName: "plate_3_speed_out_of_tolerance_fault",
        description: "Indicates that plate 3 speed is out of tolerance.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_switched_off_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Switched Off Fault",
        machineName: "plate_3_switched_off_fault",
        description: "Indicates that plate 3 is switched off.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    load_station_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Load Station Prox Switch Fault",
        machineName: "load_station_prox_switch_fault",
        description: "Indicates that there is a fault with the load station proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    oven_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Prox Switch Fault",
        machineName: "oven_prox_switch_fault",
        description: "Indicates that there is a fault with the oven proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    wait_station_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Wait Station Prox Switch Fault",
        machineName: "wait_station_prox_switch_fault",
        description: "Indicates that there is a fault with the wait station proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    cooling_station_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cooling Station Prox Switch Fault",
        machineName: "cooling_station_prox_switch_fault",
        description: "Indicates that there is a fault with the cooling station proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    unload_station_prox_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Unload Station Prox Switch Fault",
        machineName: "unload_station_prox_switch_fault",
        description: "Indicates that there is a fault with the unload station proximity switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,


    oven_entry_door_not_in_auto_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Not in Auto Fault",
        machineName: "oven_entry_door_not_in_auto_fault",
        description: "Indicates that the oven entry door is not in auto mode.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_not_in_auto_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Not in Auto Fault",
        machineName: "oven_exit_door_not_in_auto_fault",
        description: "Indicates that the oven exit door is not in auto mode.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_door_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Drive Fault",
        machineName: "oven_entry_door_drive_fault",
        description: "Indicates that there is a fault with the oven entry door drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_drive_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Drive Fault",
        machineName: "oven_exit_door_drive_fault",
        description: "Indicates that there is a fault with the oven exit door drive.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_door_failed_to_open_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Failed to Open Fault",
        machineName: "oven_entry_door_failed_to_open_fault",
        description: "Indicates that the oven entry door failed to open.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_failed_to_open_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Failed to Open Fault",
        machineName: "oven_exit_door_failed_to_open_fault",
        description: "Indicates that the oven exit door failed to open.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_door_failed_to_close_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Failed to Close Fault",
        machineName: "oven_entry_door_failed_to_close_fault",
        description: "Indicates that the oven entry door failed to close.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_failed_to_close_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Failed to Close Fault",
        machineName: "oven_exit_door_failed_to_close_fault",
        description: "Indicates that the oven exit door failed to close.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Switch Fault",
        machineName: "oven_entry_switch_fault",
        description: "Indicates that there is a fault with the oven entry switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_switch_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Switch Fault",
        machineName: "oven_exit_switch_fault",
        description: "Indicates that there is a fault with the oven exit switch.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    loss_of_oven_flame_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Loss of Oven Flame Fault",
        machineName: "loss_of_oven_flame_fault",
        description: "Indicates that there is a loss of oven flame.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_over_temperature_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Over Temperature Fault",
        machineName: "oven_over_temperature_fault",
        description: "Indicates that the oven is over temperature.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_high_gas_pressure_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven High Gas Pressure Fault",
        machineName: "oven_high_gas_pressure_fault",
        description: "Indicates that the oven has high gas pressure.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_low_gas_pressure_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Low Gas Pressure Fault",
        machineName: "oven_low_gas_pressure_fault",
        description: "Indicates that the oven has low gas pressure.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_recirculation_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Recirculation Fault",
        machineName: "oven_recirculation_fault",
        description: "Indicates that there is a fault with the oven recirculation.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exhaust_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exhaust Fault",
        machineName: "oven_exhaust_fault",
        description: "Indicates that there is a fault with the oven exhaust.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_combustion_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Combustion Fault",
        machineName: "oven_combustion_fault",
        description: "Indicates that there is a fault with the oven combustion.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_motor_overload_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Motor Overload Fault",
        machineName: "oven_motor_overload_fault",
        description: "Indicates that the oven motor is overloaded.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,

    oven_empty_arm_1_waiting_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Empty Arm 1 Waiting Fault",
        machineName: "oven_empty_arm_1_waiting_fault",
        description: "Indicates that the oven is empty and arm 1 is waiting.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_empty_arm_2_waiting_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Empty Arm 2 Waiting Fault",
        machineName: "oven_empty_arm_2_waiting_fault",
        description: "Indicates that the oven is empty and arm 2 is waiting.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_empty_arm_3_waiting_fault: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Empty Arm 3 Waiting Fault",
        machineName: "oven_empty_arm_3_waiting_fault",
        description: "Indicates that the oven is empty and arm 3 is waiting.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_temperature: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Oven Temperature",
        machineName: "oven_temperature",
        description: "The current oven temperature.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
    oven_temperature_setpoint: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Oven Temperature Setpoint",
        machineName: "oven_temperature_setpoint",
        description: "The oven temperature setpoint.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
    cart_1_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 Forward Command",
        machineName: "cart_1_forward_cmd",
        description: "Indicates that the forward command is given to cart 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 Reverse Command",
        machineName: "cart_1_reverse_cmd",
        description: "Indicates that the reverse command is given to cart 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_1_fast_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 1 Fast Command",
        machineName: "cart_1_fast_cmd",
        description: "Indicates that the fast command is given to cart 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 Forward Command",
        machineName: "cart_2_forward_cmd",
        description: "Indicates that the forward command is given to cart 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 Reverse Command",
        machineName: "cart_2_reverse_cmd",
        description: "Indicates that the reverse command is given to cart 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_2_fast_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 2 Fast Command",
        machineName: "cart_2_fast_cmd",
        description: "Indicates that the fast command is given to cart 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 Forward Command",
        machineName: "cart_3_forward_cmd",
        description: "Indicates that the forward command is given to cart 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 Reverse Command",
        machineName: "cart_3_reverse_cmd",
        description: "Indicates that the reverse command is given to cart 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    cart_3_fast_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Cart 3 Fast Command",
        machineName: "cart_3_fast_cmd",
        description: "Indicates that the fast command is given to cart 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Forward Command",
        machineName: "arm_1_forward_cmd",
        description: "Indicates that the forward command is given to arm 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 1 Reverse Command",
        machineName: "arm_1_reverse_cmd",
        description: "Indicates that the reverse command is given to arm 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Forward Command",
        machineName: "arm_2_forward_cmd",
        description: "Indicates that the forward command is given to arm 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_2_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 2 Reverse Command",
        machineName: "arm_2_reverse_cmd",
        description: "Indicates that the reverse command is given to arm 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Forward Command",
        machineName: "arm_3_forward_cmd",
        description: "Indicates that the forward command is given to arm 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_3_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Arm 3 Reverse Command",
        machineName: "arm_3_reverse_cmd",
        description: "Indicates that the reverse command is given to arm 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Forward Command",
        machineName: "plate_1_forward_cmd",
        description: "Indicates that the forward command is given to plate 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_1_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 1 Reverse Command",
        machineName: "plate_1_reverse_cmd",
        description: "Indicates that the reverse command is given to plate 1.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Forward Command",
        machineName: "plate_2_forward_cmd",
        description: "Indicates that the forward command is given to plate 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_2_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 2 Reverse Command",
        machineName: "plate_2_reverse_cmd",
        description: "Indicates that the reverse command is given to plate 2.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_forward_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Forward Command",
        machineName: "plate_3_forward_cmd",
        description: "Indicates that the forward command is given to plate 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    plate_3_reverse_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Plate 3 Reverse Command",
        machineName: "plate_3_reverse_cmd",
        description: "Indicates that the reverse command is given to plate 3.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_door_open_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Open Command",
        machineName: "oven_entry_door_open_cmd",
        description: "Indicates that the open command is given to the oven entry door.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_door_close_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Close Command",
        machineName: "oven_entry_door_close_cmd",
        description: "Indicates that the close command is given to the oven entry door.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_entry_door_fast_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Entry Door Fast Command",
        machineName: "oven_entry_door_fast_cmd",
        description: "Indicates that the fast command is given to the oven entry door.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_open_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Open Command",
        machineName: "oven_exit_door_open_cmd",
        description: "Indicates that the open command is given to the oven exit door.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_close_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Close Command",
        machineName: "oven_exit_door_close_cmd",
        description: "Indicates that the close command is given to the oven exit door.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    oven_exit_door_fast_cmd: ChannelOverride<FerryMachine_DigitalInput, {
        displayName: "Oven Exit Door Fast Command",
        machineName: "oven_exit_door_fast_cmd",
        description: "Indicates that the fast command is given to the oven exit door.",
        channelType: FerryMachineChannelType.DigitalInput,
    }>,
    arm_1_speed_setting: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Arm 1 Speed Setting",
        machineName: "arm_1_speed_setting",
        description: "The speed setting for arm 1.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
    plate_1_speed_setting: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Plate 1 Speed Setting",
        machineName: "plate_1_speed_setting",
        description: "The speed setting for plate 1.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
    arm_2_speed_setting: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Arm 2 Speed Setting",
        machineName: "arm_2_speed_setting",
        description: "The speed setting for arm 2.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
    plate_2_speed_setting: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Plate 2 Speed Setting",
        machineName: "plate_2_speed_setting",
        description: "The speed setting for plate 2.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
    arm_3_speed_setting: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Arm 3 Speed Setting",
        machineName: "arm_3_speed_setting",
        description: "The speed setting for arm 3.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
    plate_3_speed_setting: ChannelOverride<FerryMachine_AnalogInput, {
        displayName: "Plate 3 Speed Setting",
        machineName: "plate_3_speed_setting",
        description: "The speed setting for plate 3.",
        channelType: FerryMachineChannelType.AnalogInput,
    }>,
}
export type ReolinkCameraMachineChannels = {
    // test: ChannelOverride<FerryMachine_DigitalInput, {
    //     displayName: "Oven Entry Door Open Switch",
    //     machineName: "oven_entry_door_open_switch",
    //     description: "Switch that indicates the oven entry door is open.",
    //     channelType: FerryMachineChannelType.DigitalInput,
    // }>,
}



export function getFerryRotoMachineChannels(originalDevice: FerryRotoMachine | null): FerryRotoMachineChannels {

    const channelNameToIdDict: Record<string, string> = Object.keys(originalDevice?.channels ?? {}).reduce((acc, key) => {
        // @ts-ignore
        let channel = originalDevice?.channels[key];
        acc[channel.machineName] = channel.id;
        return acc;
    }, {} as { [key: string]: string });

    console.log("channelNameToIdDict", channelNameToIdDict);

    let channels: FerryRotoMachineChannels = {
        cart_1_forward_cmd: {
            id: channelNameToIdDict["cart_1_forward_cmd"] ?? generateId(),
            displayName: "Cart 1 Forward Command",
            machineName: "cart_1_forward_cmd",
            description: "Indicates that the forward command is given to cart 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_1_reverse_cmd: {
            id: channelNameToIdDict["cart_1_reverse_cmd"] ?? generateId(),
            displayName: "Cart 1 Reverse Command",
            machineName: "cart_1_reverse_cmd",
            description: "Indicates that the reverse command is given to cart 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_1_fast_cmd: {
            id: channelNameToIdDict["cart_1_fast_cmd"] ?? generateId(),
            displayName: "Cart 1 Fast Command",
            machineName: "cart_1_fast_cmd",
            description: "Indicates that the fast command is given to cart 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_2_forward_cmd: {
            id: channelNameToIdDict["cart_2_forward_cmd"] ?? generateId(),
            displayName: "Cart 2 Forward Command",
            machineName: "cart_2_forward_cmd",
            description: "Indicates that the forward command is given to cart 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_2_reverse_cmd: {
            id: channelNameToIdDict["cart_2_reverse_cmd"] ?? generateId(),
            displayName: "Cart 2 Reverse Command",
            machineName: "cart_2_reverse_cmd",
            description: "Indicates that the reverse command is given to cart 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_2_fast_cmd: {
            id: channelNameToIdDict["cart_2_fast_cmd"] ?? generateId(),
            displayName: "Cart 2 Fast Command",
            machineName: "cart_2_fast_cmd",
            description: "Indicates that the fast command is given to cart 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_3_forward_cmd: {
            id: channelNameToIdDict["cart_3_forward_cmd"] ?? generateId(),
            displayName: "Cart 3 Forward Command",
            machineName: "cart_3_forward_cmd",
            description: "Indicates that the forward command is given to cart 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_3_reverse_cmd: {
            id: channelNameToIdDict["cart_3_reverse_cmd"] ?? generateId(),
            displayName: "Cart 3 Reverse Command",
            machineName: "cart_3_reverse_cmd",
            description: "Indicates that the reverse command is given to cart 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        cart_3_fast_cmd: {
            id: channelNameToIdDict["cart_3_fast_cmd"] ?? generateId(),
            displayName: "Cart 3 Fast Command",
            machineName: "cart_3_fast_cmd",
            description: "Indicates that the fast command is given to cart 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        arm_1_forward_cmd: {
            id: channelNameToIdDict["arm_1_forward_cmd"] ?? generateId(),
            displayName: "Arm 1 Forward Command",
            machineName: "arm_1_forward_cmd",
            description: "Indicates that the forward command is given to arm 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        arm_1_reverse_cmd: {
            id: channelNameToIdDict["arm_1_reverse_cmd"] ?? generateId(),
            displayName: "Arm 1 Reverse Command",
            machineName: "arm_1_reverse_cmd",
            description: "Indicates that the reverse command is given to arm 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        arm_2_forward_cmd: {
            id: channelNameToIdDict["arm_2_forward_cmd"] ?? generateId(),
            displayName: "Arm 2 Forward Command",
            machineName: "arm_2_forward_cmd",
            description: "Indicates that the forward command is given to arm 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        arm_2_reverse_cmd: {
            id: channelNameToIdDict["arm_2_reverse_cmd"] ?? generateId(),
            displayName: "Arm 2 Reverse Command",
            machineName: "arm_2_reverse_cmd",
            description: "Indicates that the reverse command is given to arm 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        arm_3_forward_cmd: {
            id: channelNameToIdDict["arm_3_forward_cmd"] ?? generateId(),
            displayName: "Arm 3 Forward Command",
            machineName: "arm_3_forward_cmd",
            description: "Indicates that the forward command is given to arm 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        arm_3_reverse_cmd: {
            id: channelNameToIdDict["arm_3_reverse_cmd"] ?? generateId(),
            displayName: "Arm 3 Reverse Command",
            machineName: "arm_3_reverse_cmd",
            description: "Indicates that the reverse command is given to arm 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        plate_1_forward_cmd: {
            id: channelNameToIdDict["plate_1_forward_cmd"] ?? generateId(),
            displayName: "Plate 1 Forward Command",
            machineName: "plate_1_forward_cmd",
            description: "Indicates that the forward command is given to plate 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        plate_1_reverse_cmd: {
            id: channelNameToIdDict["plate_1_reverse_cmd"] ?? generateId(),
            displayName: "Plate 1 Reverse Command",
            machineName: "plate_1_reverse_cmd",
            description: "Indicates that the reverse command is given to plate 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        plate_2_forward_cmd: {
            id: channelNameToIdDict["plate_2_forward_cmd"] ?? generateId(),
            displayName: "Plate 2 Forward Command",
            machineName: "plate_2_forward_cmd",
            description: "Indicates that the forward command is given to plate 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        plate_2_reverse_cmd: {
            id: channelNameToIdDict["plate_2_reverse_cmd"] ?? generateId(),
            displayName: "Plate 2 Reverse Command",
            machineName: "plate_2_reverse_cmd",
            description: "Indicates that the reverse command is given to plate 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        plate_3_forward_cmd: {
            id: channelNameToIdDict["plate_3_forward_cmd"] ?? generateId(),
            displayName: "Plate 3 Forward Command",
            machineName: "plate_3_forward_cmd",
            description: "Indicates that the forward command is given to plate 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        plate_3_reverse_cmd: {
            id: channelNameToIdDict["plate_3_reverse_cmd"] ?? generateId(),
            displayName: "Plate 3 Reverse Command",
            machineName: "plate_3_reverse_cmd",
            description: "Indicates that the reverse command is given to plate 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        oven_entry_door_open_cmd: {
            id: channelNameToIdDict["oven_entry_door_open_cmd"] ?? generateId(),
            displayName: "Oven Entry Door Open Command",
            machineName: "oven_entry_door_open_cmd",
            description: "Indicates that the open command is given to the oven entry door.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        oven_entry_door_close_cmd: {
            id: channelNameToIdDict["oven_entry_door_close_cmd"] ?? generateId(),
            displayName: "Oven Entry Door Close Command",
            machineName: "oven_entry_door_close_cmd",
            description: "Indicates that the close command is given to the oven entry door.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        oven_entry_door_fast_cmd: {
            id: channelNameToIdDict["oven_entry_door_fast_cmd"] ?? generateId(),
            displayName: "Oven Entry Door Fast Command",
            machineName: "oven_entry_door_fast_cmd",
            description: "Indicates that the fast command is given to the oven entry door.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        oven_exit_door_open_cmd: {
            id: channelNameToIdDict["oven_exit_door_open_cmd"] ?? generateId(),
            displayName: "Oven Exit Door Open Command",
            machineName: "oven_exit_door_open_cmd",
            description: "Indicates that the open command is given to the oven exit door.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        oven_exit_door_close_cmd: {
            id: channelNameToIdDict["oven_exit_door_close_cmd"] ?? generateId(),
            displayName: "Oven Exit Door Close Command",
            machineName: "oven_exit_door_close_cmd",
            description: "Indicates that the close command is given to the oven exit door.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        oven_exit_door_fast_cmd: {
            id: channelNameToIdDict["oven_exit_door_fast_cmd"] ?? generateId(),
            displayName: "Oven Exit Door Fast Command",
            machineName: "oven_exit_door_fast_cmd",
            description: "Indicates that the fast command is given to the oven exit door.",
            channelType: FerryMachineChannelType.DigitalInput,
            updatedOn: new Date(),
            units: "",
        },
        arm_1_speed_setting: {
            id: channelNameToIdDict["arm_1_speed_setting"] ?? generateId(),
            displayName: "Arm 1 Speed Setting",
            machineName: "arm_1_speed_setting",
            description: "The speed setting for arm 1.",
            channelType: FerryMachineChannelType.AnalogInput,
            updatedOn: new Date(),
            units: "rpm",
        },
        plate_1_speed_setting: {
            id: channelNameToIdDict["plate_1_speed_setting"] ?? generateId(),
            displayName: "Plate 1 Speed Setting",
            machineName: "plate_1_speed_setting",
            description: "The speed setting for plate 1.",
            channelType: FerryMachineChannelType.AnalogInput,
            updatedOn: new Date(),
            units: "rpm",
        },
        arm_2_speed_setting: {
            id: channelNameToIdDict["arm_2_speed_setting"] ?? generateId(),
            displayName: "Arm 2 Speed Setting",
            machineName: "arm_2_speed_setting",
            description: "The speed setting for arm 2.",
            channelType: FerryMachineChannelType.AnalogInput,
            updatedOn: new Date(),
            units: "rpm",
        },
        plate_2_speed_setting: {
            id: channelNameToIdDict["plate_2_speed_setting"] ?? generateId(),
            displayName: "Plate 2 Speed Setting",
            machineName: "plate_2_speed_setting",
            description: "The speed setting for plate 2.",
            channelType: FerryMachineChannelType.AnalogInput,
            updatedOn: new Date(),
            units: "rpm",
        },
        arm_3_speed_setting: {
            id: channelNameToIdDict["arm_3_speed_setting"] ?? generateId(),
            displayName: "Arm 3 Speed Setting",
            machineName: "arm_3_speed_setting",
            description: "The speed setting for arm 3.",
            channelType: FerryMachineChannelType.AnalogInput,
            updatedOn: new Date(),
            units: "rpm",
        },
        plate_3_speed_setting: {
            id: channelNameToIdDict["plate_3_speed_setting"] ?? generateId(),
            displayName: "Plate 3 Speed Setting",
            machineName: "plate_3_speed_setting",
            description: "The speed setting for plate 3.",
            channelType: FerryMachineChannelType.AnalogInput,
            updatedOn: new Date(),
            units: "rpm",
        },
        oven_temperature: {
            id: channelNameToIdDict["oven_temperature"] ?? generateId(),
            displayName: "Oven Temperature",
            machineName: "oven_temperature",
            description: "The current oven temperature.",
            channelType: FerryMachineChannelType.AnalogInput,
            units: "°F",
            updatedOn: new Date(),
        },
        oven_temperature_setpoint: {
            id: channelNameToIdDict["oven_temperature_setpoint"] ?? generateId(),
            displayName: "Oven Temperature Setpoint",
            machineName: "oven_temperature_setpoint",
            description: "The oven temperature setpoint.",
            channelType: FerryMachineChannelType.AnalogInput,
            units: "°F",
            updatedOn: new Date(),
        },
        oven_entry_door_open_switch: {
            id: channelNameToIdDict["oven_entry_door_open_switch"] ?? generateId(),
            displayName: "Oven Entry Door Open Switch",
            machineName: "oven_entry_door_open_switch",
            description: "Switch that indicates the oven entry door is open.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_entry_door_closed_switch: {
            id: channelNameToIdDict["oven_entry_door_closed_switch"] ?? generateId(),
            displayName: "Oven Entry Door Closed Switch",
            machineName: "oven_entry_door_closed_switch",
            description: "Switch that indicates the oven entry door is closed.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_door_open_switch: {
            id: channelNameToIdDict["oven_exit_door_open_switch"] ?? generateId(),
            displayName: "Oven Exit Door Open Switch",
            machineName: "oven_exit_door_open_switch",
            description: "Switch that indicates the oven exit door is open.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_door_closed_switch: {
            id: channelNameToIdDict["oven_exit_door_closed_switch"] ?? generateId(),
            displayName: "Oven Exit Door Closed Switch",
            machineName: "oven_exit_door_closed_switch",
            description: "Switch that indicates the oven exit door is closed.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        alarm_silence_pushbutton: {
            id: channelNameToIdDict["alarm_silence_pushbutton"] ?? generateId(),
            displayName: "Alarm Silence Pushbutton",
            machineName: "alarm_silence_pushbutton",
            description: "Indicates that the alarm silence pushbutton is pressed.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_index_auto_selector_switch: {
            id: channelNameToIdDict["arm_index_auto_selector_switch"] ?? generateId(),
            displayName: "Arm Index Auto Selector Switch",
            machineName: "arm_index_auto_selector_switch",
            description: "Indicates that the arm index selector switch is set to auto.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_index_manual_selector_switch: {
            id: channelNameToIdDict["arm_index_manual_selector_switch"] ?? generateId(),
            displayName: "Arm Index Manual Selector Switch",
            machineName: "arm_index_manual_selector_switch",
            description: "Indicates that the arm index selector switch is set to manual.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_index_reverse_selector_switch: {
            id: channelNameToIdDict["arm_index_reverse_selector_switch"] ?? generateId(),
            displayName: "Arm Index Reverse Selector Switch",
            machineName: "arm_index_reverse_selector_switch",
            description: "Indicates that the arm index selector switch is set to reverse.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        drives_start_pushbutton: {
            id: channelNameToIdDict["drives_start_pushbutton"] ?? generateId(),
            displayName: "Drives Start Pushbutton",
            machineName: "drives_start_pushbutton",
            description: "Indicates that the drives start pushbutton is pressed.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        drives_stop_pushbutton: {
            id: channelNameToIdDict["drives_stop_pushbutton"] ?? generateId(),
            displayName: "Drives Stop Pushbutton",
            machineName: "drives_stop_pushbutton",
            description: "Indicates that the drives stop pushbutton is pressed.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        unload_pedestal_arm_jog_fwd_selector_switch: {
            id: channelNameToIdDict["unload_pedestal_arm_jog_fwd_selector_switch"] ?? generateId(),
            displayName: "Unload Pedestal Arm Jog Fwd Selector Switch",
            machineName: "unload_pedestal_arm_jog_fwd_selector_switch",
            description: "Indicates that the unload pedestal arm jog selector switch is set to forward.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        unload_pedestal_arm_jog_rev_selector_switch: {
            id: channelNameToIdDict["unload_pedestal_arm_jog_rev_selector_switch"] ?? generateId(),
            displayName: "Unload Pedestal Arm Jog Rev Selector Switch",
            machineName: "unload_pedestal_arm_jog_rev_selector_switch",
            description: "Indicates that the unload pedestal arm jog selector switch is set to reverse.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        unload_pedestal_plate_jog_fwd_selector_switch: {
            id: channelNameToIdDict["unload_pedestal_plate_jog_fwd_selector_switch"] ?? generateId(),
            displayName: "Unload Pedestal Plate Jog Fwd Selector Switch",
            machineName: "unload_pedestal_plate_jog_fwd_selector_switch",
            description: "Indicates that the unload pedestal plate jog selector switch is set to forward.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        unload_pedestal_plate_jog_rev_selector_switch: {
            id: channelNameToIdDict["unload_pedestal_plate_jog_rev_selector_switch"] ?? generateId(),
            displayName: "Unload Pedestal Plate Jog Rev Selector Switch",
            machineName: "unload_pedestal_plate_jog_rev_selector_switch",
            description: "Indicates that the unload pedestal plate jog selector switch is set to reverse.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        load_pedestal_arm_jog_fwd_selector_switch: {
            id: channelNameToIdDict["load_pedestal_arm_jog_fwd_selector_switch"] ?? generateId(),
            displayName: "Load Pedestal Arm Jog Fwd Selector Switch",
            machineName: "load_pedestal_arm_jog_fwd_selector_switch",
            description: "Indicates that the load pedestal arm jog selector switch is set to forward.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        load_pedestal_arm_jog_rev_selector_switch: {
            id: channelNameToIdDict["load_pedestal_arm_jog_rev_selector_switch"] ?? generateId(),
            displayName: "Load Pedestal Arm Jog Rev Selector Switch",
            machineName: "load_pedestal_arm_jog_rev_selector_switch",
            description: "Indicates that the load pedestal arm jog selector switch is set to reverse.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        load_pedestal_plate_jog_fwd_selector_switch: {
            id: channelNameToIdDict["load_pedestal_plate_jog_fwd_selector_switch"] ?? generateId(),
            displayName: "Load Pedestal Plate Jog Fwd Selector Switch",
            machineName: "load_pedestal_plate_jog_fwd_selector_switch",
            description: "Indicates that the load pedestal plate jog selector switch is set to forward.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        load_pedestal_plate_jog_rev_selector_switch: {
            id: channelNameToIdDict["load_pedestal_plate_jog_rev_selector_switch"] ?? generateId(),
            displayName: "Load Pedestal Plate Jog Rev Selector Switch",
            machineName: "load_pedestal_plate_jog_rev_selector_switch",
            description: "Indicates that the load pedestal plate jog selector switch is set to reverse.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        load_arm_ready_pushbutton: {
            id: channelNameToIdDict["load_arm_ready_pushbutton"] ?? generateId(),
            displayName: "Load Arm Ready Pushbutton",
            machineName: "load_arm_ready_pushbutton",
            description: "Indicates that the arm ready pushbutton is pressed on the load station pedestal.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        load_cycle_reset_pushbutton: {
            id: channelNameToIdDict["load_cycle_reset_pushbutton"] ?? generateId(),
            displayName: "Load Cycle Reset Pushbutton",
            machineName: "load_cycle_reset_pushbutton",
            description: "Indicates that the cycle reset pushbutton is pressed on the load station pedestal.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        unload_arm_ready_pushbutton: {
            id: channelNameToIdDict["unload_arm_ready_pushbutton"] ?? generateId(),
            displayName: "Unload Arm Ready Pushbutton",
            machineName: "unload_arm_ready_pushbutton",
            description: "Indicates that the arm ready pushbutton is pressed on the unload station pedestal.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        unload_cycle_reset_pushbutton: {
            id: channelNameToIdDict["unload_cycle_reset_pushbutton"] ?? generateId(),
            displayName: "Unload Cycle Reset Pushbutton",
            machineName: "unload_cycle_reset_pushbutton",
            description: "Indicates that the cycle reset pushbutton is pressed on the unload station pedestal.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        cart_1_at_load_station_prox_switch: {
            id: channelNameToIdDict["cart_1_at_load_station_prox_switch"] ?? generateId(),
            displayName: "Cart 1 at Load Station Prox Switch",
            machineName: "cart_1_at_load_station_prox_switch",
            description: "Indicates that cart 1 is at the load station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_1_at_oven_prox_switch: {
            id: channelNameToIdDict["cart_1_at_oven_prox_switch"] ?? generateId(),
            displayName: "Cart 1 at Oven Prox Switch",
            machineName: "cart_1_at_oven_prox_switch",
            description: "Indicates that cart 1 is at the oven.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_1_at_wait_station_prox_switch: {
            id: channelNameToIdDict["cart_1_at_wait_station_prox_switch"] ?? generateId(),
            displayName: "Cart 1 at Wait Station Prox Switch",
            machineName: "cart_1_at_wait_station_prox_switch",
            description: "Indicates that cart 1 is at the wait station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_1_at_cooling_station_prox_switch: {
            id: channelNameToIdDict["cart_1_at_cooling_station_prox_switch"] ?? generateId(),
            displayName: "Cart 1 at Cooling Station Prox Switch",
            machineName: "cart_1_at_cooling_station_prox_switch",
            description: "Indicates that cart 1 is at the cooling station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_1_at_unload_station_prox_switch: {
            id: channelNameToIdDict["cart_1_at_unload_station_prox_switch"] ?? generateId(),
            displayName: "Cart 1 at Unload Station Prox Switch",
            machineName: "cart_1_at_unload_station_prox_switch",
            description: "Indicates that cart 1 is at the unload station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_1_index_pushbutton: {
            id: channelNameToIdDict["cart_1_index_pushbutton"] ?? generateId(),
            displayName: "Cart 1 Index Pushbutton",
            machineName: "cart_1_index_pushbutton",
            description: "Indicates that the index pushbutton is pressed for cart 1.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        cart_2_at_load_station_prox_switch: {
            id: channelNameToIdDict["cart_2_at_load_station_prox_switch"] ?? generateId(),
            displayName: "Cart 2 at Load Station Prox Switch",
            machineName: "cart_2_at_load_station_prox_switch",
            description: "Indicates that cart 2 is at the load station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_at_oven_prox_switch: {
            id: channelNameToIdDict["cart_2_at_oven_prox_switch"] ?? generateId(),
            displayName: "Cart 2 at Oven Prox Switch",
            machineName: "cart_2_at_oven_prox_switch",
            description: "Indicates that cart 2 is at the oven.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_at_wait_station_prox_switch: {
            id: channelNameToIdDict["cart_2_at_wait_station_prox_switch"] ?? generateId(),
            displayName: "Cart 2 at Wait Station Prox Switch",
            machineName: "cart_2_at_wait_station_prox_switch",
            description: "Indicates that cart 2 is at the wait station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_at_cooling_station_prox_switch: {
            id: channelNameToIdDict["cart_2_at_cooling_station_prox_switch"] ?? generateId(),
            displayName: "Cart 2 at Cooling Station Prox Switch",
            machineName: "cart_2_at_cooling_station_prox_switch",
            description: "Indicates that cart 2 is at the cooling station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_at_unload_station_prox_switch: {
            id: channelNameToIdDict["cart_2_at_unload_station_prox_switch"] ?? generateId(),
            displayName: "Cart 2 at Unload Station Prox Switch",
            machineName: "cart_2_at_unload_station_prox_switch",
            description: "Indicates that cart 2 is at the unload station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_index_pushbutton: {
            id: channelNameToIdDict["cart_2_index_pushbutton"] ?? generateId(),
            displayName: "Cart 2 Index Pushbutton",
            machineName: "cart_2_index_pushbutton",
            description: "Indicates that the index pushbutton is pressed for cart 2.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        cart_3_at_load_station_prox_switch: {
            id: channelNameToIdDict["cart_3_at_load_station_prox_switch"] ?? generateId(),
            displayName: "Cart 3 at Load Station Prox Switch",
            machineName: "cart_3_at_load_station_prox_switch",
            description: "Indicates that cart 3 is at the load station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_at_oven_prox_switch: {
            id: channelNameToIdDict["cart_3_at_oven_prox_switch"] ?? generateId(),
            displayName: "Cart 3 at Oven Prox Switch",
            machineName: "cart_3_at_oven_prox_switch",
            description: "Indicates that cart 3 is at the oven.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_at_wait_station_prox_switch: {
            id: channelNameToIdDict["cart_3_at_wait_station_prox_switch"] ?? generateId(),
            displayName: "Cart 3 at Wait Station Prox Switch",
            machineName: "cart_3_at_wait_station_prox_switch",
            description: "Indicates that cart 3 is at the wait station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_at_cooling_station_prox_switch: {
            id: channelNameToIdDict["cart_3_at_cooling_station_prox_switch"] ?? generateId(),
            displayName: "Cart 3 at Cooling Station Prox Switch",
            machineName: "cart_3_at_cooling_station_prox_switch",
            description: "Indicates that cart 3 is at the cooling station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_at_unload_station_prox_switch: {
            id: channelNameToIdDict["cart_3_at_unload_station_prox_switch"] ?? generateId(),
            displayName: "Cart 3 at Unload Station Prox Switch",
            machineName: "cart_3_at_unload_station_prox_switch",
            description: "Indicates that cart 3 is at the unload station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_index_pushbutton: {
            id: channelNameToIdDict["cart_3_index_pushbutton"] ?? generateId(),
            displayName: "Cart 3 Index Pushbutton",
            machineName: "cart_3_index_pushbutton",
            description: "Indicates that the index pushbutton is pressed for cart 3.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        plate_1_cam_prox_switch: {
            id: channelNameToIdDict["plate_1_cam_prox_switch"] ?? generateId(),
            displayName: "Plate 1 Cam Prox Switch",
            machineName: "plate_1_cam_prox_switch",
            description: "Indicates that plate 1 proximity switch is triggered.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_1_cam_prox_switch: {
            id: channelNameToIdDict["arm_1_cam_prox_switch"] ?? generateId(),
            displayName: "Arm 1 Cam Prox Switch",
            machineName: "arm_1_cam_prox_switch",
            description: "Indicates that arm 1 proximity switch is triggered.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_1_brake_relay: {
            id: channelNameToIdDict["arm_1_brake_relay"] ?? generateId(),
            displayName: "Arm 1 Brake Relay",
            machineName: "arm_1_brake_relay",
            description: "Indicates that arm 1 brake relay is active.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_1_brake_relay: {
            id: channelNameToIdDict["plate_1_brake_relay"] ?? generateId(),
            displayName: "Plate 1 Brake Relay",
            machineName: "plate_1_brake_relay",
            description: "Indicates that plate 1 brake relay is active.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        plate_2_cam_prox_switch: {
            id: channelNameToIdDict["plate_2_cam_prox_switch"] ?? generateId(),
            displayName: "Plate 2 Cam Prox Switch",
            machineName: "plate_2_cam_prox_switch",
            description: "Indicates that plate 2 proximity switch is triggered.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_2_cam_prox_switch: {
            id: channelNameToIdDict["arm_2_cam_prox_switch"] ?? generateId(),
            displayName: "Arm 2 Cam Prox Switch",
            machineName: "arm_2_cam_prox_switch",
            description: "Indicates that arm 2 proximity switch is triggered.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_2_brake_relay: {
            id: channelNameToIdDict["arm_2_brake_relay"] ?? generateId(),
            displayName: "Arm 2 Brake Relay",
            machineName: "arm_2_brake_relay",
            description: "Indicates that arm 2 brake relay is active.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_2_brake_relay: {
            id: channelNameToIdDict["plate_2_brake_relay"] ?? generateId(),
            displayName: "Plate 2 Brake Relay",
            machineName: "plate_2_brake_relay",
            description: "Indicates that plate 2 brake relay is active.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        plate_3_cam_prox_switch: {
            id: channelNameToIdDict["plate_3_cam_prox_switch"] ?? generateId(),
            displayName: "Plate 3 Cam Prox Switch",
            machineName: "plate_3_cam_prox_switch",
            description: "Indicates that plate 3 proximity switch is triggered.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_3_cam_prox_switch: {
            id: channelNameToIdDict["arm_3_cam_prox_switch"] ?? generateId(),
            displayName: "Arm 3 Cam Prox Switch",
            machineName: "arm_3_cam_prox_switch",
            description: "Indicates that arm 3 proximity switch is triggered.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_3_brake_relay: {
            id: channelNameToIdDict["arm_3_brake_relay"] ?? generateId(),
            displayName: "Arm 3 Brake Relay",
            machineName: "arm_3_brake_relay",
            description: "Indicates that arm 3 brake relay is active.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_3_brake_relay: {
            id: channelNameToIdDict["plate_3_brake_relay"] ?? generateId(),
            displayName: "Plate 3 Brake Relay",
            machineName: "plate_3_brake_relay",
            description: "Indicates that plate 3 brake relay is active.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        flame_fail: {
            id: channelNameToIdDict["flame_fail"] ?? generateId(),
            displayName: "Flame Fail",
            machineName: "flame_fail",
            description: "Indicates that the flame has failed.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        recirculation_pressure_ok_switch: {
            id: channelNameToIdDict["recirculation_pressure_ok_switch"] ?? generateId(),
            displayName: "Recirculation Pressure OK Switch",
            machineName: "recirculation_pressure_ok_switch",
            description: "Indicates that the recirculation pressure is OK.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        exhaust_pressure_ok_switch: {
            id: channelNameToIdDict["exhaust_pressure_ok_switch"] ?? generateId(),
            displayName: "Exhaust Pressure OK Switch",
            machineName: "exhaust_pressure_ok_switch",
            description: "Indicates that the exhaust pressure is OK.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        burner_pressure_ok_switch: {
            id: channelNameToIdDict["burner_pressure_ok_switch"] ?? generateId(),
            displayName: "Burner Pressure OK Switch",
            machineName: "burner_pressure_ok_switch",
            description: "Indicates that the burner pressure is OK.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        high_gas_pressure_switch: {
            id: channelNameToIdDict["high_gas_pressure_switch"] ?? generateId(),
            displayName: "High Gas Pressure Switch",
            machineName: "high_gas_pressure_switch",
            description: "Indicates that the high limit gas pressure switch is tripped.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        low_gas_pressure_switch: {
            id: channelNameToIdDict["low_gas_pressure_switch"] ?? generateId(),
            displayName: "Low Gas Pressure Switch",
            machineName: "low_gas_pressure_switch",
            description: "Indicates that the low limit gas pressure switch is tripped.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        cart_1_drive_fault: {
            id: channelNameToIdDict["cart_1_drive_fault"] ?? generateId(),
            displayName: "Cart 1 Drive Fault",
            machineName: "cart_1_drive_fault",
            description: "Indicates that there is a fault with cart 1 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_drive_fault: {
            id: channelNameToIdDict["cart_2_drive_fault"] ?? generateId(),
            displayName: "Cart 2 Drive Fault",
            machineName: "cart_2_drive_fault",
            description: "Indicates that there is a fault with cart 2 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_drive_fault: {
            id: channelNameToIdDict["cart_3_drive_fault"] ?? generateId(),
            displayName: "Cart 3 Drive Fault",
            machineName: "cart_3_drive_fault",
            description: "Indicates that there is a fault with cart 3 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_1_drive_fault: {
            id: channelNameToIdDict["arm_1_drive_fault"] ?? generateId(),
            displayName: "Arm 1 Drive Fault",
            machineName: "arm_1_drive_fault",
            description: "Indicates that there is a fault with arm 1 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_2_drive_fault: {
            id: channelNameToIdDict["arm_2_drive_fault"] ?? generateId(),
            displayName: "Arm 2 Drive Fault",
            machineName: "arm_2_drive_fault",
            description: "Indicates that there is a fault with arm 2 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_3_drive_fault: {
            id: channelNameToIdDict["arm_3_drive_fault"] ?? generateId(),
            displayName: "Arm 3 Drive Fault",
            machineName: "arm_3_drive_fault",
            description: "Indicates that there is a fault with arm 3 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_1_drive_fault: {
            id: channelNameToIdDict["plate_1_drive_fault"] ?? generateId(),
            displayName: "Plate 1 Drive Fault",
            machineName: "plate_1_drive_fault",
            description: "Indicates that there is a fault with plate 1 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_2_drive_fault: {
            id: channelNameToIdDict["plate_2_drive_fault"] ?? generateId(),
            displayName: "Plate 2 Drive Fault",
            machineName: "plate_2_drive_fault",
            description: "Indicates that there is a fault with plate 2 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_3_drive_fault: {
            id: channelNameToIdDict["plate_3_drive_fault"] ?? generateId(),
            displayName: "Plate 3 Drive Fault",
            machineName: "plate_3_drive_fault",
            description: "Indicates that there is a fault with plate 3 drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_entry_drive_fault: {
            id: channelNameToIdDict["oven_entry_drive_fault"] ?? generateId(),
            displayName: "Oven Entry Drive Fault",
            machineName: "oven_entry_drive_fault",
            description: "Indicates that there is a fault with oven entry drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_drive_fault: {
            id: channelNameToIdDict["oven_exit_drive_fault"] ?? generateId(),
            displayName: "Oven Exit Drive Fault",
            machineName: "oven_exit_drive_fault",
            description: "Indicates that there is a fault with oven exit drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        cart_1_is_not_on_station_fault: {
            id: channelNameToIdDict["cart_1_is_not_on_station_fault"] ?? generateId(),
            displayName: "Cart 1 is Not on Station Fault",
            machineName: "cart_1_is_not_on_station_fault",
            description: "Indicates that cart 1 is not on any station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_1_is_not_indexing_fault: {
            id: channelNameToIdDict["cart_1_is_not_indexing_fault"] ?? generateId(),
            displayName: "Cart 1 is Not Indexing Fault",
            machineName: "cart_1_is_not_indexing_fault",
            description: "Indicates that cart 1 is not indexing.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_1_prox_switch_fault: {
            id: channelNameToIdDict["cart_1_prox_switch_fault"] ?? generateId(),
            displayName: "Cart 1 Prox Switch Fault",
            machineName: "cart_1_prox_switch_fault",
            description: "Indicates that there is a fault with cart 1 proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_1_brake_fault: {
            id: channelNameToIdDict["arm_1_brake_fault"] ?? generateId(),
            displayName: "Arm 1 Brake Fault",
            machineName: "arm_1_brake_fault",
            description: "Indicates that there is a fault with arm 1 brake.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_1_not_rotating_fault: {
            id: channelNameToIdDict["arm_1_not_rotating_fault"] ?? generateId(),
            displayName: "Arm 1 Not Rotating Fault",
            machineName: "arm_1_not_rotating_fault",
            description: "Indicates that arm 1 is not rotating.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_1_speed_out_of_tolerance_fault: {
            id: channelNameToIdDict["arm_1_speed_out_of_tolerance_fault"] ?? generateId(),
            displayName: "Arm 1 Speed Out of Tolerance Fault",
            machineName: "arm_1_speed_out_of_tolerance_fault",
            description: "Indicates that arm 1 speed is out of tolerance.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_1_switched_off_fault: {
            id: channelNameToIdDict["arm_1_switched_off_fault"] ?? generateId(),
            displayName: "Arm 1 Switched Off Fault",
            machineName: "arm_1_switched_off_fault",
            description: "Indicates that arm 1 is switched off.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_1_brake_fault: {
            id: channelNameToIdDict["plate_1_brake_fault"] ?? generateId(),
            displayName: "Plate 1 Brake Fault",
            machineName: "plate_1_brake_fault",
            description: "Indicates that there is a fault with plate 1 brake.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_1_not_rotating_fault: {
            id: channelNameToIdDict["plate_1_not_rotating_fault"] ?? generateId(),
            displayName: "Plate 1 Not Rotating Fault",
            machineName: "plate_1_not_rotating_fault",
            description: "Indicates that plate 1 is not rotating.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_1_speed_out_of_tolerance_fault: {
            id: channelNameToIdDict["plate_1_speed_out_of_tolerance_fault"] ?? generateId(),
            displayName: "Plate 1 Speed Out of Tolerance Fault",
            machineName: "plate_1_speed_out_of_tolerance_fault",
            description: "Indicates that plate 1 speed is out of tolerance.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_1_switched_off_fault: {
            id: channelNameToIdDict["plate_1_switched_off_fault"] ?? generateId(),
            displayName: "Plate 1 Switched Off Fault",
            machineName: "plate_1_switched_off_fault",
            description: "Indicates that plate 1 is switched off.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        cart_2_is_not_on_station_fault: {
            id: channelNameToIdDict["cart_2_is_not_on_station_fault"] ?? generateId(),
            displayName: "Cart 2 is Not on Station Fault",
            machineName: "cart_2_is_not_on_station_fault",
            description: "Indicates that cart 2 is not on any station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_is_not_indexing_fault: {
            id: channelNameToIdDict["cart_2_is_not_indexing_fault"] ?? generateId(),
            displayName: "Cart 2 is Not Indexing Fault",
            machineName: "cart_2_is_not_indexing_fault",
            description: "Indicates that cart 2 is not indexing.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_2_prox_switch_fault: {
            id: channelNameToIdDict["cart_2_prox_switch_fault"] ?? generateId(),
            displayName: "Cart 2 Prox Switch Fault",
            machineName: "cart_2_prox_switch_fault",
            description: "Indicates that there is a fault with cart 2 proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_2_brake_fault: {
            id: channelNameToIdDict["arm_2_brake_fault"] ?? generateId(),
            displayName: "Arm 2 Brake Fault",
            machineName: "arm_2_brake_fault",
            description: "Indicates that there is a fault with arm 2 brake.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_2_not_rotating_fault: {
            id: channelNameToIdDict["arm_2_not_rotating_fault"] ?? generateId(),
            displayName: "Arm 2 Not Rotating Fault",
            machineName: "arm_2_not_rotating_fault",
            description: "Indicates that arm 2 is not rotating.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_2_speed_out_of_tolerance_fault: {
            id: channelNameToIdDict["arm_2_speed_out_of_tolerance_fault"] ?? generateId(),
            displayName: "Arm 2 Speed Out of Tolerance Fault",
            machineName: "arm_2_speed_out_of_tolerance_fault",
            description: "Indicates that arm 2 speed is out of tolerance.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_2_switched_off_fault: {
            id: channelNameToIdDict["arm_2_switched_off_fault"] ?? generateId(),
            displayName: "Arm 2 Switched Off Fault",
            machineName: "arm_2_switched_off_fault",
            description: "Indicates that arm 2 is switched off.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_2_brake_fault: {
            id: channelNameToIdDict["plate_2_brake_fault"] ?? generateId(),
            displayName: "Plate 2 Brake Fault",
            machineName: "plate_2_brake_fault",
            description: "Indicates that there is a fault with plate 2 brake.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_2_not_rotating_fault: {
            id: channelNameToIdDict["plate_2_not_rotating_fault"] ?? generateId(),
            displayName: "Plate 2 Not Rotating Fault",
            machineName: "plate_2_not_rotating_fault",
            description: "Indicates that plate 2 is not rotating.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_2_speed_out_of_tolerance_fault: {
            id: channelNameToIdDict["plate_2_speed_out_of_tolerance_fault"] ?? generateId(),
            displayName: "Plate 2 Speed Out of Tolerance Fault",
            machineName: "plate_2_speed_out_of_tolerance_fault",
            description: "Indicates that plate 2 speed is out of tolerance.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_2_switched_off_fault: {
            id: channelNameToIdDict["plate_2_switched_off_fault"] ?? generateId(),
            displayName: "Plate 2 Switched Off Fault",
            machineName: "plate_2_switched_off_fault",
            description: "Indicates that plate 2 is switched off.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        cart_3_is_not_on_station_fault: {
            id: channelNameToIdDict["cart_3_is_not_on_station_fault"] ?? generateId(),
            displayName: "Cart 3 is Not on Station Fault",
            machineName: "cart_3_is_not_on_station_fault",
            description: "Indicates that cart 3 is not on any station.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_is_not_indexing_fault: {
            id: channelNameToIdDict["cart_3_is_not_indexing_fault"] ?? generateId(),
            displayName: "Cart 3 is Not Indexing Fault",
            machineName: "cart_3_is_not_indexing_fault",
            description: "Indicates that cart 3 is not indexing.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        cart_3_prox_switch_fault: {
            id: channelNameToIdDict["cart_3_prox_switch_fault"] ?? generateId(),
            displayName: "Cart 3 Prox Switch Fault",
            machineName: "cart_3_prox_switch_fault",
            description: "Indicates that there is a fault with cart 3 proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_3_brake_fault: {
            id: channelNameToIdDict["arm_3_brake_fault"] ?? generateId(),
            displayName: "Arm 3 Brake Fault",
            machineName: "arm_3_brake_fault",
            description: "Indicates that there is a fault with arm 3 brake.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_3_not_rotating_fault: {
            id: channelNameToIdDict["arm_3_not_rotating_fault"] ?? generateId(),
            displayName: "Arm 3 Not Rotating Fault",
            machineName: "arm_3_not_rotating_fault",
            description: "Indicates that arm 3 is not rotating.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_3_speed_out_of_tolerance_fault: {
            id: channelNameToIdDict["arm_3_speed_out_of_tolerance_fault"] ?? generateId(),
            displayName: "Arm 3 Speed Out of Tolerance Fault",
            machineName: "arm_3_speed_out_of_tolerance_fault",
            description: "Indicates that arm 3 speed is out of tolerance.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        arm_3_switched_off_fault: {
            id: channelNameToIdDict["arm_3_switched_off_fault"] ?? generateId(),
            displayName: "Arm 3 Switched Off Fault",
            machineName: "arm_3_switched_off_fault",
            description: "Indicates that arm 3 is switched off.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_3_brake_fault: {
            id: channelNameToIdDict["plate_3_brake_fault"] ?? generateId(),
            displayName: "Plate 3 Brake Fault",
            machineName: "plate_3_brake_fault",
            description: "Indicates that there is a fault with plate 3 brake.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_3_not_rotating_fault: {
            id: channelNameToIdDict["plate_3_not_rotating_fault"] ?? generateId(),
            displayName: "Plate 3 Not Rotating Fault",
            machineName: "plate_3_not_rotating_fault",
            description: "Indicates that plate 3 is not rotating.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_3_speed_out_of_tolerance_fault: {
            id: channelNameToIdDict["plate_3_speed_out_of_tolerance_fault"] ?? generateId(),
            displayName: "Plate 3 Speed Out of Tolerance Fault",
            machineName: "plate_3_speed_out_of_tolerance_fault",
            description: "Indicates that plate 3 speed is out of tolerance.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        plate_3_switched_off_fault: {
            id: channelNameToIdDict["plate_3_switched_off_fault"] ?? generateId(),
            displayName: "Plate 3 Switched Off Fault",
            machineName: "plate_3_switched_off_fault",
            description: "Indicates that plate 3 is switched off.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        load_station_prox_switch_fault: {
            id: channelNameToIdDict["load_station_prox_switch_fault"] ?? generateId(),
            displayName: "Load Station Prox Switch Fault",
            machineName: "load_station_prox_switch_fault",
            description: "Indicates that there is a fault with the load station proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        oven_prox_switch_fault: {
            id: channelNameToIdDict["oven_prox_switch_fault"] ?? generateId(),
            displayName: "Oven Prox Switch Fault",
            machineName: "oven_prox_switch_fault",
            description: "Indicates that there is a fault with the oven proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        wait_station_prox_switch_fault: {
            id: channelNameToIdDict["wait_station_prox_switch_fault"] ?? generateId(),
            displayName: "Wait Station Prox Switch Fault",
            machineName: "wait_station_prox_switch_fault",
            description: "Indicates that there is a fault with the wait station proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        cooling_station_prox_switch_fault: {
            id: channelNameToIdDict["cooling_station_prox_switch_fault"] ?? generateId(),
            displayName: "Cooling Station Prox Switch Fault",
            machineName: "cooling_station_prox_switch_fault",
            description: "Indicates that there is a fault with the cooling station proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        unload_station_prox_switch_fault: {
            id: channelNameToIdDict["unload_station_prox_switch_fault"] ?? generateId(),
            displayName: "Unload Station Prox Switch Fault",
            machineName: "unload_station_prox_switch_fault",
            description: "Indicates that there is a fault with the unload station proximity switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },


        oven_entry_door_not_in_auto_fault: {
            id: channelNameToIdDict["oven_entry_door_not_in_auto_fault"] ?? generateId(),
            displayName: "Oven Entry Door Not in Auto Fault",
            machineName: "oven_entry_door_not_in_auto_fault",
            description: "Indicates that the oven entry door is not in auto mode.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_door_not_in_auto_fault: {
            id: channelNameToIdDict["oven_exit_door_not_in_auto_fault"] ?? generateId(),
            displayName: "Oven Exit Door Not in Auto Fault",
            machineName: "oven_exit_door_not_in_auto_fault",
            description: "Indicates that the oven exit door is not in auto mode.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_entry_door_drive_fault: {
            id: channelNameToIdDict["oven_entry_door_drive_fault"] ?? generateId(),
            displayName: "Oven Entry Door Drive Fault",
            machineName: "oven_entry_door_drive_fault",
            description: "Indicates that there is a fault with the oven entry door drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_door_drive_fault: {
            id: channelNameToIdDict["oven_exit_door_drive_fault"] ?? generateId(),
            displayName: "Oven Exit Door Drive Fault",
            machineName: "oven_exit_door_drive_fault",
            description: "Indicates that there is a fault with the oven exit door drive.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_entry_door_failed_to_open_fault: {
            id: channelNameToIdDict["oven_entry_door_failed_to_open_fault"] ?? generateId(),
            displayName: "Oven Entry Door Failed to Open Fault",
            machineName: "oven_entry_door_failed_to_open_fault",
            description: "Indicates that the oven entry door failed to open.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_door_failed_to_open_fault: {
            id: channelNameToIdDict["oven_exit_door_failed_to_open_fault"] ?? generateId(),
            displayName: "Oven Exit Door Failed to Open Fault",
            machineName: "oven_exit_door_failed_to_open_fault",
            description: "Indicates that the oven exit door failed to open.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_entry_door_failed_to_close_fault: {
            id: channelNameToIdDict["oven_entry_door_failed_to_close_fault"] ?? generateId(),
            displayName: "Oven Entry Door Failed to Close Fault",
            machineName: "oven_entry_door_failed_to_close_fault",
            description: "Indicates that the oven entry door failed to close.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_door_failed_to_close_fault: {
            id: channelNameToIdDict["oven_exit_door_failed_to_close_fault"] ?? generateId(),
            displayName: "Oven Exit Door Failed to Close Fault",
            machineName: "oven_exit_door_failed_to_close_fault",
            description: "Indicates that the oven exit door failed to close.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_entry_switch_fault: {
            id: channelNameToIdDict["oven_entry_switch_fault"] ?? generateId(),
            displayName: "Oven Entry Switch Fault",
            machineName: "oven_entry_switch_fault",
            description: "Indicates that there is a fault with the oven entry switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exit_switch_fault: {
            id: channelNameToIdDict["oven_exit_switch_fault"] ?? generateId(),
            displayName: "Oven Exit Switch Fault",
            machineName: "oven_exit_switch_fault",
            description: "Indicates that there is a fault with the oven exit switch.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        loss_of_oven_flame_fault: {
            id: channelNameToIdDict["loss_of_oven_flame_fault"] ?? generateId(),
            displayName: "Loss of Oven Flame Fault",
            machineName: "loss_of_oven_flame_fault",
            description: "Indicates that there is a loss of oven flame.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_over_temperature_fault: {
            id: channelNameToIdDict["oven_over_temperature_fault"] ?? generateId(),
            displayName: "Oven Over Temperature Fault",
            machineName: "oven_over_temperature_fault",
            description: "Indicates that the oven is over temperature.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_high_gas_pressure_fault: {
            id: channelNameToIdDict["oven_high_gas_pressure_fault"] ?? generateId(),
            displayName: "Oven High Gas Pressure Fault",
            machineName: "oven_high_gas_pressure_fault",
            description: "Indicates that the oven has high gas pressure.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_low_gas_pressure_fault: {
            id: channelNameToIdDict["oven_low_gas_pressure_fault"] ?? generateId(),
            displayName: "Oven Low Gas Pressure Fault",
            machineName: "oven_low_gas_pressure_fault",
            description: "Indicates that the oven has low gas pressure.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_recirculation_fault: {
            id: channelNameToIdDict["oven_recirculation_fault"] ?? generateId(),
            displayName: "Oven Recirculation Fault",
            machineName: "oven_recirculation_fault",
            description: "Indicates that there is a fault with the oven recirculation.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_exhaust_fault: {
            id: channelNameToIdDict["oven_exhaust_fault"] ?? generateId(),
            displayName: "Oven Exhaust Fault",
            machineName: "oven_exhaust_fault",
            description: "Indicates that there is a fault with the oven exhaust.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_combustion_fault: {
            id: channelNameToIdDict["oven_combustion_fault"] ?? generateId(),
            displayName: "Oven Combustion Fault",
            machineName: "oven_combustion_fault",
            description: "Indicates that there is a fault with the oven combustion.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_motor_overload_fault: {
            id: channelNameToIdDict["oven_motor_overload_fault"] ?? generateId(),
            displayName: "Oven Motor Overload Fault",
            machineName: "oven_motor_overload_fault",
            description: "Indicates that the oven motor is overloaded.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

        oven_empty_arm_1_waiting_fault: {
            id: channelNameToIdDict["oven_empty_arm_1_waiting_fault"] ?? generateId(),
            displayName: "Oven Empty Arm 1 Waiting Fault",
            machineName: "oven_empty_arm_1_waiting_fault",
            description: "Indicates that the oven is empty and arm 1 is waiting.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_empty_arm_2_waiting_fault: {
            id: channelNameToIdDict["oven_empty_arm_2_waiting_fault"] ?? generateId(),
            displayName: "Oven Empty Arm 2 Waiting Fault",
            machineName: "oven_empty_arm_2_waiting_fault",
            description: "Indicates that the oven is empty and arm 2 is waiting.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },
        oven_empty_arm_3_waiting_fault: {
            id: channelNameToIdDict["oven_empty_arm_3_waiting_fault"] ?? generateId(),
            displayName: "Oven Empty Arm 3 Waiting Fault",
            machineName: "oven_empty_arm_3_waiting_fault",
            description: "Indicates that the oven is empty and arm 3 is waiting.",
            channelType: FerryMachineChannelType.DigitalInput,
            units: "",
            updatedOn: new Date(),
        },

    }

    const updatedChannelIds = Object.values(channels).map(channel => channel.id).sort();

    console.log("Updated channel ids: ", updatedChannelIds);

    return channels;
}

export enum FerryMachineChannelType {
    DigitalInput = "DigitalInput",
    AnalogInput = "AnalogInput",
}


export interface FerryMachine_DigitalInput extends Channel {
    channelType: FerryMachineChannelType.DigitalInput;
}


export interface FerryMachine_AnalogInput extends Channel {
    channelType: FerryMachineChannelType.AnalogInput;
}